import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import { organizationSetIsLoadingReducerType } from './OrganizationConstants';

export const initialState = Map({
  isLoading: false,
});

const spec = {
  [organizationSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
};

export default createReducerBySpec(spec, initialState);
